export default __webpack_public_path__ + "static/media/instragram1.c82714bf.jpg";